// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Erro na configuração do Supabase:', {
    url: supabaseUrl ? '✅ Definida' : '❌ Não definida',
    key: supabaseAnonKey ? '✅ Definida' : '❌ Não definida',
    environment: process.env.NODE_ENV,
    debug: process.env.REACT_APP_DEBUG
  });
  throw new Error('❌ REACT_APP_SUPABASE_URL e REACT_APP_SUPABASE_ANON_KEY devem ser definidas nas variáveis de ambiente');
}

if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_DEBUG === 'true') {
  console.log('🔧 Configuração do Supabase:');
  console.log(`🌍 Ambiente: ${process.env.NODE_ENV}`);
  console.log(`📡 URL: ${supabaseUrl}`);
  console.log(`🔑 Chave: ${supabaseAnonKey.substring(0, 20)}...`);
  console.log('✅ Supabase configurado com sucesso!');
}

// Configuração melhorada do cliente Supabase
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    // Configurações adicionais para lidar com mudanças de visibilidade
    storageKey: 'supabase.auth.token',
    storage: window.localStorage,
    debug: false//process.env.NODE_ENV === 'development'
  },
  // Configurações de rede para melhor recuperação de conexão
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  },
  global: {
    headers: {
      'x-client-info': 'supabase-js-web'
    }
  }
});

export default supabase;